import styled from 'styled-components';

export const StyledTourClickCatcher = styled.div`
  position: fixed;
  inset: 0;
  z-index: 200;
`;

export const StyledTourHighlight = styled.div`
  position: fixed;
  z-index: 201;
  border-radius: 10px;
  box-shadow: 0 0 0 9999px rgba(15, 13, 35, 0.55),
    0 0 0 3px var(--brand-green);
  pointer-events: none;
  transition: all 0.25s ease;
`;

export const StyledTourBackdrop = styled.div`
  position: fixed;
  inset: 0;
  z-index: 201;
  background: rgba(15, 13, 35, 0.55);
`;

export const StyledTourPopover = styled.div`
  position: fixed;
  z-index: 202;
  width: 340px;
  max-width: calc(100vw - 32px);
  background: var(--surface);
  border: 1px solid var(--line);
  border-radius: var(--r-lg, 14px);
  box-shadow: var(--sh-2), 0 12px 40px -12px rgba(20, 18, 43, 0.35);
  padding: var(--s-4, 16px);
`;

export const StyledTourBadgeRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: var(--s-2, 8px);
`;

export const StyledTourBadge = styled.span`
  display: inline-block;
  padding: 2px 10px;
  border-radius: var(--r-full, 9999px);
  background: var(--brand-green-soft, rgba(118, 177, 89, 0.12));
  color: var(--brand-green);
  font-size: var(--t-xs, 12px);
  font-weight: 700;
  letter-spacing: 0.04em;
  text-transform: uppercase;
`;

export const StyledTourCount = styled.span`
  font-size: var(--t-xs, 12px);
  color: var(--muted);
  font-variant-numeric: tabular-nums;
`;

export const StyledTourTitle = styled.h3`
  margin: 0 0 var(--s-2, 8px);
  font-size: var(--t-lg, 17px);
  font-weight: 700;
  color: var(--ink);
`;

export const StyledTourBody = styled.p`
  margin: 0 0 var(--s-4, 16px);
  font-size: var(--t-sm, 14px);
  line-height: 1.5;
  color: var(--ink-2, var(--ink));
`;

export const StyledTourFooter = styled.div`
  display: flex;
  align-items: center;
  gap: var(--s-2, 8px);
`;

export const StyledTourSkip = styled.button`
  appearance: none;
  border: none;
  background: transparent;
  padding: 8px 4px;
  cursor: pointer;
  font-size: var(--t-sm, 14px);
  font-weight: 600;
  color: var(--muted);
  margin-inline-end: auto;

  &:hover {
    color: var(--ink);
  }
`;

export const StyledTourButton = styled.button<{ primary?: boolean }>`
  appearance: none;
  cursor: pointer;
  padding: 8px 16px;
  border-radius: var(--r-md, 8px);
  font-size: var(--t-sm, 14px);
  font-weight: 600;
  border: 1px solid
    ${({ primary }) => (primary ? 'var(--brand-green)' : 'var(--line)')};
  background: ${({ primary }) =>
    primary ? 'var(--brand-green)' : 'var(--surface)'};
  color: ${({ primary }) => (primary ? '#fff' : 'var(--ink)')};

  &:hover {
    filter: brightness(0.97);
  }
`;

export const StyledHelpButton = styled.button`
  appearance: none;
  border: none;
  cursor: pointer;
  width: 34px;
  height: 34px;
  flex: none;
  display: grid;
  place-items: center;
  border-radius: var(--r-full, 9999px);
  background: transparent;
  color: var(--muted);

  &:hover {
    background: var(--paper-2, #f2f0ea);
    color: var(--ink);
  }

  svg {
    width: 19px;
    height: 19px;
    fill: none;
  }
`;
